import { get } from 'lodash';
import React, { FC } from 'react';
import SummaryLine from 'src/components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN, KOSTEN_POSITION, NACHWEIS_POSITION_STATUS } from 'src/lib/constants/constant';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import { DisplayDateTime, DisplayEuroMUI } from 'src/utils/formats';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';
const MA_P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const AbschlussMaStipendium: FC<{}> = () => {
	const { application } = useApplication();
	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
	const getAusgabenByStatus = (status: string) => {
		const nachweisposition = (nachweispositionen as any[]).find((eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
		return Number(get(nachweisposition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	};
	const getEinnahmePositionByKostenart = (kostenart: string) =>
		(nachweispositionen as any[]).find(
			(eachPosition: any) =>
				get(eachPosition, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme &&
				get(eachPosition, NP_P.Allgemein_Kostenart_Finanzierung.path) === kostenart,
		);
	const eigenmittelPosition = getEinnahmePositionByKostenart(KOSTEN_ARTEN.Eigenmittel);
	const oeffentlicheMittelPosition = getEinnahmePositionByKostenart(KOSTEN_ARTEN.OeffentlicheMittel);
	const angefallen = getAusgabenByStatus(NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const geplant = getAusgabenByStatus(NACHWEIS_POSITION_STATUS.geplant);
	const eigenmittelBetrag = Number(get(eigenmittelPosition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	const oeffentlicheMittelBetrag = Number(get(oeffentlicheMittelPosition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	const eigenUndDrittmittelGesamt = eigenmittelBetrag + oeffentlicheMittelBetrag;
	const eigenmittelLabel =
		get(eigenmittelPosition, NP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path, '') ||
		get(eigenmittelPosition, NP_P.Allgemein_Bezeichnung.path, 'Eigenmittel');
	const oeffentlicheMittelLabel =
		get(oeffentlicheMittelPosition, NP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path, '') ||
		get(oeffentlicheMittelPosition, NP_P.Allgemein_Bezeichnung.path, 'öffentliche Mittel');
	const bemessungsgrundlage = angefallen + geplant - eigenUndDrittmittelGesamt;
	return (
		<>
			<AbschlussSeiteBox>
				<SummaryLine
					label='Datum der Einreichung'
					value={
						get(application, MA_P.Allgemein_Eingereicht_Am.path) ?
							DisplayDateTime(get(application, MA_P.Allgemein_Eingereicht_Am.path))
						:	'noch nicht eingereicht'
					}
				/>
				<SummaryLine label='Projekttitel' value={get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')} />
				<SummaryLine label='Projektausgaben' value={''} />
				<SummaryLine label='bis jetzt angefallene Projektausgaben' value={DisplayEuroMUI(angefallen)} labelPadding={'0.75rem 0 0.75rem 2rem'} />
				<SummaryLine
					label={`in den nächsten drei Monaten anfallende Projektausgaben`}
					value={DisplayEuroMUI(geplant)}
					labelPadding={'0.75rem 0 0.75rem 2rem'}
				/>
				<SummaryLine label='Eigenmittel und öffentliche Mittel' value={DisplayEuroMUI(eigenUndDrittmittelGesamt)} />
				<SummaryLine label={`abzügl. ${eigenmittelLabel}`} value={DisplayEuroMUI(eigenmittelBetrag)} labelPadding={'0.75rem 0 0.75rem 2rem'} />
				<SummaryLine
					label={`abzügl. ${oeffentlicheMittelLabel}`}
					value={DisplayEuroMUI(oeffentlicheMittelBetrag)}
					labelPadding={'0.75rem 0 0.75rem 2rem'}
				/>
				<SummaryLine label='Bemessungsgrundlage' value={DisplayEuroMUI(bemessungsgrundlage)} />
				<SummaryLine
					label='Mittelabruf'
					value={DisplayEuroMUI(get(application, MA_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path, 0))}
				/>
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussMaStipendium;
